module.exports = __webpack_public_path__ + "img/9.dd72e5cf.jpg";